import { render, staticRenderFns } from "./FilePreviewDialog.vue?vue&type=template&id=f8c68acc&"
import script from "./FilePreviewDialog.vue?vue&type=script&lang=js&"
export * from "./FilePreviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports